{
  "AGENT_BOTS": {
    "HEADER": "Bots",
    "LOADING_EDITOR": "Loading editor...",
    "DESCRIPTION": "Agent Bots are like the most fabulous members of your team. They can handle the small stuff, so you can focus on the stuff that matters. Give them a try.You can manage your bots from this page or create new ones using the 'Configure new bot' button.",
    "LEARN_MORE": "Learn about agent bots",
    "GLOBAL_BOT_BADGE": "Systeem",
    "AVATAR": {
      "SUCCESS_DELETE": "Bot-avatar succesvol verwijderd",
      "ERROR_DELETE": "Fout bij het verwijderen van de bot-avatar, probeer het opnieuw"
    },
    "CSML_BOT_EDITOR": {
      "NAME": {
        "LABEL": "Bot Naam",
        "PLACEHOLDER": "Name your bot.",
        "ERROR": "Bot naam is vereist."
      },
      "DESCRIPTION": {
        "LABEL": "Bot description",
        "PLACEHOLDER": "Wat doet deze bot?"
      },
      "BOT_CONFIG": {
        "ERROR": "Vul uw CSML bot configuratie hierboven in.",
        "API_ERROR": "Your CSML configuration is invalid. Please fix it and try again."
      },
      "SUBMIT": "Valideren en opslaan"
    },
    "BOT_CONFIGURATION": {
      "TITLE": "Selecteer een agent bot",
      "DESC": "Assign an Agent Bot to your inbox. They can handle initial conversations and transfer them to a live agent when necessary.",
      "OPTION": "{name} ({description})",
      "SUBMIT": "Vernieuwen",
      "DISCONNECT": "Disconnect bot",
      "SUCCESS_MESSAGE": "De agent bot is succesvol bijgewerkt.",
      "DISCONNECTED_SUCCESS_MESSAGE": "Succesvol de agent bot verbinding verbroken.",
      "ERROR_MESSAGE": "Could not update the agent bot. Please try again.",
      "DISCONNECTED_ERROR_MESSAGE": "Could not disconnect the agent bot. Please try again.",
      "SELECT_PLACEHOLDER": "Select bot",
      "COUNTRY_BOTS": {
        "TITLE": "Bots per land",
        "DESC": "Deze inbox bedient meerdere landen. Een gesprek gaat naar de bot van zijn land: op basis van de Kaufland-winkel, de marktplaats van de Allegro-bestelling, of anders de taal waarin de klant schrijft. Alle andere gesprekken gaan naar de standaardbot hierboven.",
        "COUNTRY": "Selecteer een land",
        "BOT": "Selecteer een bot",
        "ADD": "Bot voor een land toevoegen",
        "REMOVE": "Verwijderen",
        "DEFAULT_REQUIRED": "Selecteer eerst een standaardbot. De bot van een land vervangt die alleen voor dat land.",
        "DISCONNECT_ALL": "Alle bots loskoppelen"
      }
    },
    "ADD": {
      "TITLE": "Configureer nieuwe bot",
      "CANCEL_BUTTON_TEXT": "Annuleren",
      "API": {
        "SUCCESS_MESSAGE": "Bot succesvol toegevoegd.",
        "ERROR_MESSAGE": "Could not add bot. Please try again later."
      }
    },
    "LIST": {
      "404": "No bots found. You can create a bot by clicking the 'Configure new bot' button ↗",
      "LOADING": "Fetching bots...",
      "TABLE_HEADER": {
        "DETAILS": "Bot-gegevens",
        "URL": "Webhook-URL"
      },
      "TYPE": "Bot type"
    },
    "DELETE": {
      "BUTTON_TEXT": "Verwijderen",
      "TITLE": "Delete bot",
      "CONFIRM": {
        "TITLE": "Verwijdering bevestigen",
        "MESSAGE": "Weet u zeker dat u {name} wilt verwijderen?",
        "YES": "Ja, verwijderen",
        "NO": "Nee, behouden"
      },
      "SUBMIT": "Verwijderen",
      "CANCEL_BUTTON_TEXT": "Annuleren",
      "DESCRIPTION": "Weet u zeker dat u deze bot wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.",
      "API": {
        "SUCCESS_MESSAGE": "Bot succesvol verwijderd.",
        "ERROR_MESSAGE": "Could not delete bot. Please try again."
      }
    },
    "EDIT": {
      "BUTTON_TEXT": "Bewerken",
      "LOADING": "Fetching bots...",
      "TITLE": "Edit bot",
      "CANCEL_BUTTON_TEXT": "Annuleren",
      "API": {
        "SUCCESS_MESSAGE": "Bot succesvol bijgewerkt.",
        "ERROR_MESSAGE": "Could not update bot. Please try again."
      }
    },
    "FORM": {
      "AVATAR": {
        "LABEL": "Bot-avatar"
      },
      "NAME": {
        "LABEL": "Botnaam",
        "PLACEHOLDER": "Voer botnaam in"
      },
      "DESCRIPTION": {
        "LABEL": "Beschrijving",
        "PLACEHOLDER": "Wat doet deze bot?"
      },
      "WEBHOOK_URL": {
        "LABEL": "Webhook-URL",
        "PLACEHOLDER": "https://example.com/webhook"
      },
      "ERRORS": {
        "NAME": "Botnaam is vereist",
        "URL": "Webhook-URL is vereist",
        "VALID_URL": "Voer een geldige URL in die begint met http:// of https://"
      },
      "CANCEL": "Annuleren",
      "CREATE": "Bot aanmaken",
      "UPDATE": "Bot bijwerken"
    },
    "TYPES": {
      "WEBHOOK": "Webhook bot",
      "CSML": "CSML bot"
    }
  }
}
